import React from 'react';
import { NextSeo } from 'next-seo';
import { useUserAgent } from 'next-useragent';
import nookies from 'nookies';
import { RootStoreProvider } from '../../../providers/RootStoreProvider';
import { Layout } from '../../../components/Layout';
import { SearchPage } from '../../../components/SearchPage';
import { Subscribe } from '../../../components/MainPage/Subscribe';
import { SearchStoreProvider } from '../../../providers/SearchStoreProvider';
import { Collapsed } from '../../../components/Collapsed';
import { seoData, hasSeo } from '../../../utils/seo';
import { apiProxy } from '../../../lib/api';
import { BreadCrumbs } from '../../../components/BreadCrumbs';
import { logger } from '../../../lib/logger';
import { containsSea } from '../../../utils/containSea';
// import { apiProxy } from "../lib/api";

export default function ResultPage({
  uaString,
  store: { popdir, url, user, seoRaw, banners, popularPopdirs },
  canonicalUrl,
}) {
  const ua = useUserAgent(uaString || window.navigator.userAgent);
  const { isMobile, isTablet } = ua;
  const pageRoute = [
    { title: `Круизы на теплоходе летом`, link: '/2026/summer' },
    { title: `Круизы на теплоходе в августе`, link: '' },
  ];

  return (
    <SearchStoreProvider hydrationData={{ popdir, url, user }}>
      <RootStoreProvider hydrationData={{ popdir, url, user }}>
        <NextSeo
          title={
            seoRaw?.seo_title.length === 0
              ? 'Круизы на теплоходе в августе 2026 года - расписание и цены'
              : seoRaw?.seo_title
          }
          description={
            seoRaw?.description.length === 0
              ? 'Речные круизы в августе 2026 на теплоходе. Онлайн-бронирование туров. Расписание на август 2026 года. Описание маршрута, цены, выбор каюты. +7 499 681-10-19'
              : seoRaw?.description
          }
          additionalLinkTags={[
            {
              rel: 'shortcut icon',
              href: '/favicon.ico?v=2',
            },
          ]}
          canonical={canonicalUrl}
        />
        <Layout
          isMobile={isMobile}
          isTablet={isTablet}
          withoutForm
          popularPopdirs={popularPopdirs}
        >
          <div className="container--block">
            <div>
              <BreadCrumbs routeCrumbs={pageRoute} />
            </div>
            <SearchPage
              noRedirectToResult
              url={url}
              popdir={popdir}
              isMobile={isMobile}
              urlBanners={banners}
            />
            <section style={{ marginTop: '24px' }}>
              {hasSeo(seoRaw, popdir) && (
                <Collapsed seo={seoData(seoRaw)} shorter isSeo />
              )}
            </section>
            <Subscribe />
          </div>
        </Layout>
      </RootStoreProvider>
    </SearchStoreProvider>
  );
}

export const getServerSideProps = async ctx => {
  const cookies = nookies.get(ctx);
  const { token } = cookies;

  // Генерация канонического URL на стадии сборки страницы
  const canonicalUrl = `https://kruiz.online${ctx.req.url}`;
  const hasSea = containsSea(ctx.req.url);
  try {
    const responses = await Promise.allSettled([
      apiProxy.get(`ApiPageSeazon/get_seazon_search?href=2026/summer/august`, {
        headers: {
          'x-request-id': ctx.req.headers['x-request-id'] ?? 'qwert',
          ym_uid: cookies._ym_uid || 'ym_cid not found',
        },
      }),
      apiProxy.get(`ApiBanners/getResultBanners`, {
        headers: {
          'x-request-id': ctx.req.headers['x-request-id'] ?? 'qwert',
          ym_uid: cookies._ym_uid || 'ym_cid not found',
        },
      }),
      apiProxy.get(`ApiPopdirNew/getHeaderPopdir/${hasSea}`, {
        headers: {
          'x-request-id': ctx.req.headers['x-request-id'] ?? 'qwert',
          ym_uid: cookies._ym_uid || 'ym_cid not found',
        },
      }),
    ]);

    const user = await apiProxy
      .get(`ApiUsers/check_token/${token ?? ''}`, {
        headers: {
          'x-request-id': ctx.req.headers['x-request-id'] ?? 'qwert',
          ym_uid: cookies._ym_uid || 'ym_cid not found',
        },
      })
      .then(resp => resp.data);

    const [seoRaw, banners, popularPopdirs] = responses.map(req =>
      req.status === 'fulfilled' ? req.value.data ?? null : null,
    );

    const popdir = {
      caption: `${
        seoRaw.h1.length === 0 ? 'Круизы на агуст 2026 года' : seoRaw.h1
      }`,
      cover_img: {
        jpg: '/images/search_page/season_banners/desktop/Август.jpg',
        webp: '/images/search_page/season_banners/desktop/Август.webp',
      },
      cover_img_mob: {
        jpg: '/images/search_page/season_banners/mobile/Август.jpg',
        webp: '/images/search_page/season_banners/mobile/Август.webp',
      },
      extraCondition: 'favoriteMonth_08_2026',
    };
    logger({
      additionalFields: {
        url: ctx.resolvedUrl,
      },
      level: 'debug',
      ym_uid: cookies._ym_uid,
      message: 'august page has been created',
    });
    return {
      props: {
        store: {
          user,
          popdir,
          url: 'year_cruis',
          seoRaw,
          banners,
          popularPopdirs,
        },
        uaString: ctx.req.headers['user-agent'],
        canonicalUrl,
      },
    };
  } catch (error) {
    logger({
      additionalFields: {
        url: ctx.resolvedUrl,
      },
      error,
      level: 'error',
      message: 'august page was not created',
    });
    return {
      redirect: {
        destination: '/503',
        permanent: true,
      },
    };
  }
};
